'use client';

import { Button, Center } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { LuShoppingCart } from 'react-icons/lu';
import { EmptyState } from '@/components/ui/empty-state';

interface EmptyCartStateProps {
  onClose: () => void;
}

export default function EmptyCartState({ onClose }: EmptyCartStateProps) {
  const t = useTranslations();

  return (
    <Center w='full'>
      <EmptyState
        size='sm'
        icon={<LuShoppingCart color='var(--primary-default)' />}
        title={t('your_cart_empty')}
        description={t('the_items_you_order_will_appear_here')}
      >
        <Button
          onClick={onClose}
          bg='primary'
          color='primary.text'
          _hover={{ bg: 'primary.hover' }}
          rounded={12}
        >
          {t('back_to_menu')}
        </Button>
      </EmptyState>
    </Center>
  );
}
